<template>
  <qc-container title="查看合同" show-return show-divider>
    <page-request ref="table" url="/api/mgr/user/contract/list" :table-header="tableHeader" :expend="expend" :prop="{contractId:$route.query.id}" :op-width="200">
      <template #op="scope">
        <b-button  @click="open(scope.row)">查看</b-button>
        <b-button @click="doDownloadPdf(scope.row)">下载</b-button>
      </template>
    </page-request>
  </qc-container>

  <open-contract ref="openContract"></open-contract>
  <download-pdf ref="downloadPdf"></download-pdf>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";
import OpenContract from "@view/lease/contract/open-contract.vue";
import Download from "@/components/upload/download.vue";
import downloadPdf from "@view/lease/contract/download-pdf.vue";
import DownloadPdf from "@view/lease/contract/download-pdf.vue";

export default {
  name: "contract-detail",
  computed: {
    downloadPdf() {
      return downloadPdf
    }
  },
  components: {DownloadPdf, Download, OpenContract, BButton, PageRequest, QcContainer},
  data() {
    return {
      tableHeader: [
        {type: "user", label: "用户"},
        {prop: "status", label: "租赁状态",renderDraw:row=>{
          if(row.status==0){
            return "待付款"
          }else if(row.status==1){
            return "租赁中";
          }else if(row.status==5){
            return "已关闭"
          }else{
            return "已完成"
          }
        },width:100
        },
        {prop: "orderCode", label: "关联订单",width:200},
        {prop: "createTime", label: "租赁时间",width:160},
      ],
      expend:[
        {label: "租赁用户", prop: "nickname"},
        {label: "用户ID", prop: "code"},
        {label: "订单编号", prop: "orderCode"},
        {label: "商家名称", prop: "shopCode"},
        {label: "商家电话", prop: "shopPhone"},
        {label: "下单时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    open(row){
      this.$refs.openContract.open(row);
    },
    doDownloadPdf(row){
      this.$refs.downloadPdf.doDownload(row);
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
